export const bodyFont =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
export const headerFont = `"Avenir Next", ${bodyFont}`;
export const monospace = 'dm, monospace';
